import { useCallback } from 'react'
import { useDispatch } from 'react-redux'
import { useI18n } from 'builder/hooks/useI18n'
import { actions as resumeDistributionActions } from 'builder/modules/resumeDistribution'
import { LOCALIZATION_KEY } from '../../constants'
import {
  Container,
  ActionContainer,
  ActionTitle,
  IconWrapper,
  ActionIcon,
  ActionDescription,
} from './styles'
import { ResumeDistributionActionProps } from './types'

export const RESUME_DISTRIBUTION_ACTION_HIGHLIGHT_ID = 'resume-distribution-action'

export const ResumeDistributionAction = ({
  resume,
  newlyCreatedResumeId,
}: ResumeDistributionActionProps) => {
  const dispatch = useDispatch()
  const { i18n } = useI18n()

  const handleClick = useCallback(() => {
    if (newlyCreatedResumeId) {
      dispatch(resumeDistributionActions.setResumeDetails(resume))
    }
  }, [dispatch, newlyCreatedResumeId, resume])

  return (
    <Container data-highlight-id={RESUME_DISTRIBUTION_ACTION_HIGHLIGHT_ID} onClick={handleClick}>
      <ActionContainer>
        <ActionTitle>{i18n.t(`${LOCALIZATION_KEY}.resume_distribution_action.title`)}</ActionTitle>
        <ActionDescription>
          {i18n.t(`${LOCALIZATION_KEY}.resume_distribution_action.description`)}
        </ActionDescription>
      </ActionContainer>
      <IconWrapper>
        <ActionIcon />
      </IconWrapper>
    </Container>
  )
}
